<div>
    <div class="title border-bottom">
        <span class="ttl"><div class="skeleton skeleton-title"></div></span>
        <div class="date d-flex justify-content-between">
            <!-- <span class="text-primary"><i class="fa fa-calendar mr-1 op-5"></i></span> -->
            <!-- <span><i class="fa fa-circle mr-1 {{'INSITE' | lowercase}}"></i>{{typeName['INSITE']}}</span> -->
        </div>
    </div>
    <div class="bg-white">
        <div class="cert d-flex justify-content-between">
            <!-- <div class="skeleton skeleton-text short"></div> -->
        </div>
        <div class="desc">
            <div class="skeleton skeleton-text mb-1"></div>
            <div class="skeleton skeleton-text mb-1"></div>
            <div class="skeleton skeleton-text short mb-1"></div>
        </div>
        <!-- <div class="address text-primary" ><i class="fa fa-building mr-2"></i> </div> -->
        <div class="bot border-top">
            <div class="_user">
                <div class="img"><div class="skeleton skeleton-img"></div></div>
                <div class="info" *ngIf="false">
                    <b>Instructor</b>
                    <span><div class="skeleton skeleton-text short"></div></span>
                </div>
            </div>
            <div class="_user">
                <div class="info text-right" *ngIf="false">
                    <b>Institución</b>
                    <span><div class="skeleton skeleton-text short"></div></span>
                </div>
                <div class="img"><div class="skeleton skeleton-img"></div></div>
            </div>
        </div>
    </div>
</div>